import { render, staticRenderFns } from "./backoffice-mapa-cirurgico.vue?vue&type=template&id=215fc0c2"
import script from "./backoffice-mapa-cirurgico.vue?vue&type=script&lang=ts"
export * from "./backoffice-mapa-cirurgico.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-mapa-cirurgico.vue?vue&type=style&index=0&id=215fc0c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports